import { IFunctionality } from '@/modules/functionality/models';

export interface State {
    functionalities: IFunctionality[];
    functionalitySelected: IFunctionality;
    showRegisterForm: boolean;
    groupedFunctionalities: any[];
}

export const state = (): State => ({
    functionalities: [],
    groupedFunctionalities: [],
    showRegisterForm: false,
    functionalitySelected: {
        idsystem: 0,
        system: {
            id: 0,
            isactive: true,
            systemname: '',
        },
        id: 0,
        description: '',
        name: '',
        userinterfaceid: '',
        contextdescription: '',
        isactive: true,
    },
});
